import has  from 'lodash/has';

export default {
    applyEmail(state) {
        return has(state, 'user.email') ? state.user.email : '';
    },

    applyFirstName(state) {
        return has(state, 'user.first_name') ? state.user.first_name : '';
    },

    applyLastName(state) {
        return has(state, 'user.last_name') ? state.user.last_name : '';
    },

    applyContactNumber(state) {
        return has(state, 'user.contact_number') ? state.user.contact_number : '';
    },

    isApplyAsExistingUser(state) {
        return state.application_type === 'existing_user';
    },

    isApplyAsNewUser(state) {
        return state.application_type === 'new_user';
    },

    isApplyAsGuestUser(state) {
        return state.application_type === 'guest_user';
    },

    isApplyAsRecognisedUser(state) {
        return has(state, 'user.email');
    },

    isApplyComplete(state) {
        return state.is_apply_complete;
    },
};
